import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";

const purchases = [
  { name: "Fajar", city: "Bandung" },
  { name: "Sinta", city: "Jakarta" },
  { name: "Bagas", city: "Surabaya" },
  { name: "Tiara", city: "Yogyakarta" },
  { name: "Reno", city: "Medan" },
  { name: "Amel", city: "Semarang" },
  { name: "Dani", city: "Makassar" },
  { name: "Vira", city: "Palembang" },
  { name: "Ilham", city: "Denpasar" },
  { name: "Kirana", city: "Malang" },
];

export const CapCutSocialProof = () => {
  const [index, setIndex] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const startTimer = setTimeout(() => setStarted(true), 5000);
    return () => clearTimeout(startTimer);
  }, []);

  useEffect(() => {
    if (!started) return;
    const id = setInterval(() => setIndex((i) => (i + 1) % purchases.length), 5000);
    return () => clearInterval(id);
  }, [started]);

  if (!started) return null;
  const p = purchases[index];

  return (
    <div className="fixed left-3 md:left-6 top-20 md:top-24 z-40 pointer-events-none">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, y: -24, scale: 0.92 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -16, scale: 0.95 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center gap-2 rounded-xl bg-white/90 backdrop-blur-xl border border-slate-200 shadow-[0_8px_28px_rgba(15,23,42,0.12)] px-3 py-2 max-w-[250px]"
          data-testid="capcut-social-proof"
        >
          <span className="shrink-0 w-7 h-7 rounded-lg bg-blue-600 flex items-center justify-center">
            <ShoppingBag className="w-3.5 h-3.5 text-white" strokeWidth={2.2} />
          </span>
          <div className="min-w-0">
            <p className="text-xs font-bold text-slate-900 leading-snug">
              {p.name} dari {p.city} baru beli CapCut Pro
            </p>
            <p className="text-[10px] text-slate-500">baru saja</p>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
